import * as React from "react";
import { withStyles, WithStyles } from "@material-ui/core/styles";

import { StyleRulesCallback, Typography } from "@material-ui/core";
import { ActionButton } from "../../Buttons/ActionButton/ActionButton";
// import { PlusIcon } from "./PlusIcon";
// import Colors from "../../../assets/Colors";

interface IProps {
  onClick?: () => void;
}

class AddMemberButtonComponent extends React.Component<
  IProps & WithStyles<any>
> {
  public render() {
    const { classes, onClick } = this.props;
    return (
      <ActionButton
        onClick={onClick}
        variant="contained"
        size="small"
        className={classes.button}
      >
        {/*<PlusIcon className={classes.icon} />*/}
        <Typography className={classes.text}>ADD MEMBER</Typography>
      </ActionButton>
    );
  }
}

const styles: StyleRulesCallback = _ => ({
  icon: {
    width: 14,
    height: 14,
    marginRight: 14
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    color: "#2F3033",

  },
  button: {
    borderRadius: 10,
    minWidth: 80,
    width: "14em",
    minHeight: 32,
    background: "#FFBA00",
    borderColor: "#FFBA00",
    color: "#2F3033",
    cursor: "pointer!important",
    '&:hover': {
      backgroundColor: "#ffcf50",
      borderColor: "#ffcf50",
    }
  }
});

export const AddMemberButton = withStyles(styles)(AddMemberButtonComponent);



// WEBPACK FOOTER //
// ./src/components/Header/components/AddMemberButton.tsx